import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

// BL lookup behind the raise dialog's BL combobox (launchpad parity).
export interface BlSearchHit {
  id: string;
  display: string;
  secondary: string | null;
}

interface BlPickerResponse {
  items: BlSearchHit[];
}

const LIMIT = 20;

export function blSearchQueryKey(search: string): readonly [string, string] {
  return ['hedging:bl-search', search] as const;
}

export function useBlSearch(search: string) {
  const trimmed = search.trim();
  return useQuery({
    queryKey: blSearchQueryKey(trimmed),
    queryFn: async ({ signal }): Promise<BlSearchHit[]> => {
      const response = await apiRequest<BlPickerResponse>('/bl-orders/picker', {
        query: { q: trimmed || undefined, limit: LIMIT },
        signal,
      });
      return response.items;
    },
    placeholderData: (previous) => previous,
  });
}
